import React, {useEffect, useState, Fragment} from "react";
import {connect} from "react-redux";
import {withSnackbar} from 'notistack';

import Button from "@material-ui/core/Button";
import FormControl from "@material-ui/core/FormControl";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import UndoIcon from '@material-ui/icons/Undo';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from "@material-ui/core/Typography";
import Slide from "@material-ui/core/Slide";

import formStyles from "../../../../../components/UI/Styles/formStyle";
import EnhancedTable from "../../../../../components/UI/Table/Table";
import {firestore} from "../../../../../firebase";

const headCells = [
    {id: 'first', label: 'First Name'},
    {id: 'last', label: 'Last Name'},
    {id: 'role', label: 'Role'},
    {id: 'approved', label: 'Approved'},
    {id: 'language', label: 'Language'},
    {id: 'email', label: 'Email'}
];

const MassChangeRole = (props) => {
    const classes = formStyles();
    const list = props.roleList;
    const [users, setUsers] = useState([]);
    const [auditHistory, setAuditHistory] = useState([]);
    const [filteredUserList, setFilteredUserList] = useState([]);
    const [role, setRole] = useState();
    const [newRole, setNewRole] = useState();

    async function getVolunteers() {
        let volunteers = [];
        const volunteerRef = await firestore.collection('users')
            .get();
        volunteerRef.forEach((user) => {
            if (user.data().approved === "true") {
                volunteers.push({...user.data(), userDocId: user.id});
            } else {
                console.log(false);
            }
        });
        setUsers(volunteers);
    }

    useEffect(() => {
        getVolunteers()
            .catch(error => console.log(error));
    }, []);

    useEffect(() => {
        const filter = users.filter(user => user.role === role);
        setFilteredUserList(filter);
    }, [role]);

    const updateRole = (user) => {
        return firestore.collection('users')
            .doc(user.userDocId)
            .update({
                        role: newRole
                    });
    };

    const updateRoles = async () => {
        let result;
        for (const user of filteredUserList) {
            result = await updateRole(user);
        }
        return result;
    };

    const updateRolesHandler = () => {
        updateRoles()
            .then(() => {
                props.enqueueSnackbar('Successfully Updated Positions', {
                    variant: "success",
                    autoHideDuration: 4000,
                    TransitionComponent: Slide,
                    anchorOrigin: {vertical: 'bottom', horizontal: 'right'}
                });
            })
            .catch(error => {
                console.log(error);
                props.enqueueSnackbar('Error Updating Positions: ' + error.message, {variant: "error"});
            });
    };

    const onSelectRoleHandler = (event) => {
        setRole(event.target.value);
        setAuditHistory([]);
    };

    const onSelectNewRoleHandler = (event) => {
        setNewRole(event.target.value);
    };

    const handleDelete = (row) => {
        const tempAH = [...auditHistory];
        tempAH.push(row);
        setAuditHistory(tempAH);

        const filter = filteredUserList.filter(user => user.userDocId !== row.userDocId);
        setFilteredUserList(filter);
    };

    const undoHandler = () => {
        const item = auditHistory.pop();
        const index = item.index;
        const undoList = [...filteredUserList.slice(0, index), item, ...filteredUserList.slice(index)];
        setFilteredUserList(undoList);
    };

    return (
        <Fragment>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel required>Select Current Role</InputLabel>
                        <Select
                            native
                            value={role}
                            onChange={onSelectRoleHandler}
                            label="Select Current Role"
                        >
                            <option aria-label="None" value=""/>
                            {list.map(listItem => {
                                return (
                                    <option key={listItem.name} value={listItem.name}>{listItem.name}</option>
                                );
                            })}
                        </Select>
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <FormControl variant="outlined" className={classes.formControl}>
                        <InputLabel required>Select New Role</InputLabel>
                        <Select
                            native
                            value={newRole}
                            onChange={onSelectNewRoleHandler}
                            label="Select New Role"
                        >
                            <option aria-label="None" value=""/>
                            {list.map(listItem => {
                                return (
                                    <option key={listItem.name} value={listItem.name}>{listItem.name}</option>
                                );
                            })}
                        </Select>
                        {(newRole === role && role !== undefined) &&
                        <FormHelperText error>The new role and current role can't be the same</FormHelperText>
                        }
                    </FormControl>
                </Grid>
                <Grid item xs={12}>
                    <Typography>
                        Using the delete button will simply remove the user from the list of users in the table below, it will NOT delete the user from the database until you click 'Update Roles'.
                        You can use the 'Undo' button to undo the last delete that took place. After a successful update the page will not refresh. This is so you can go between roles and not
                        cross update. For example: If you update every M1 to M2, and then go to update M2 to M3,
                        the newly updated M2's will not be mixed in until you refresh the page.
                    </Typography>
                </Grid>
                {role &&
                <Grid item xs={12}>
                    <Button onClick={undoHandler} disabled={auditHistory.length === 0} variant={"contained"}
                            color={"primary"}>Undo <UndoIcon/></Button>
                </Grid>
                }
                {role &&
                <Grid item xs={12}>
                    <EnhancedTable
                        data={filteredUserList}
                        headCells={headCells}
                        delete={handleDelete}
                        noPagination
                    />
                </Grid>
                }
                {role &&
                <Grid item xs={12}>
                    <Button onClick={updateRolesHandler}
                            variant={"contained"}
                            color={"primary"}
                            disabled={filteredUserList.length === 0 || !newRole || newRole === role}>Update
                        Roles</Button>
                </Grid>
                }
            </Grid>
        </Fragment>
    );
};

const mapStateToProps = state => {
    return {
        roleList: state.lists.roleList,
    };
};

export default connect(mapStateToProps)(withSnackbar(MassChangeRole));
